import type { Show, Snackbar, Type } from "@/types/store/snackbar";
import { defineStore } from "pinia";

export const useSnackbar = defineStore("snackbar", {
  state: () => ({
    show: false as Show,
    text: "" as string,
    type: "" as Type,
    timeout: 2000,
    transition: "slide-x-reverse-transition" as "slide-x-reverse-transition",
  }),
  actions: {
    reset() {
      this.show = false;
      this.text = "";
    },
    showSnackbar(payload: Snackbar) {
      this.reset();
      this.show = true;
      this.text = payload.text;
      this.type = payload.type;
    },
  },
});
